import { validateCPF, validateEmail, validatePhone } from '@/utils/inputMasks';
import { ValidationRule } from '@/hooks/useFormValidation';

export interface PersonalData {
  name: string;
  email: string;
  phoneNumber: string;
  documentNumber: string;
}

export const personalDataValidationRules: ValidationRule<PersonalData>[] = [
  {
    field: 'name',
    validate: (value: string) => {
      if (!value?.trim()) return "Nome é obrigatório";
      if (value.trim().split(' ').length < 2) return "Informe o nome completo";
      return null;
    }
  },
  {
    field: 'email',
    validate: (value: string) => {
      if (!value) return "Email é obrigatório";
      if (!validateEmail(value)) return "Email inválido";
      return null;
    }
  },
  {
    field: 'phoneNumber',
    validate: (value: string) => {
      if (!value) return "Telefone é obrigatório";
      if (!validatePhone(value)) return "Telefone inválido";
      return null;
    }
  },
  {
    field: 'documentNumber',
    validate: (value: string) => {
      if (!value) return "CPF é obrigatório";
      if (!validateCPF(value)) return "CPF inválido";
      return null;
    }
  }
];
